import Vue from 'vue'
import { API_IMG_HOST } from './local.js'
Vue.filter('formatDate', function (timeStr) {
  if (timeStr === 0) {
    return '----'
  }
  var time = new Date(timeStr * 1000)
  var y = time.getFullYear()
  var m = time.getMonth() + 1 < 10 ? '0' + (time.getMonth() + 1) : time.getMonth() + 1
  var d = time.getDate() < 10 ? '0' + time.getDate() : time.getDate()
  var h = time.getHours() < 10 ? '0' + time.getHours() : time.getHours()
  var mm = time.getMinutes() < 10 ? '0' + time.getMinutes() : time.getMinutes()
  // var s = time.getSeconds() < 10 ? '0' + time.getSeconds() : time.getSeconds()
  return y + '-' + m + '-' + d + ' ' + h + ':' + mm
})
Vue.filter('formatDateForAnalyse', function (timeStr) {
  if (timeStr === 0) {
    return ''
  }
  var time = new Date(timeStr * 1000)
  var y = time.getFullYear()
  var m = time.getMonth() + 1 < 10 ? '0' + (time.getMonth() + 1) : time.getMonth() + 1
  var d = time.getDate() < 10 ? '0' + time.getDate() : time.getDate()
  var h = time.getHours() < 10 ? '0' + time.getHours() : time.getHours()
  var mm = time.getMinutes() < 10 ? '0' + time.getMinutes() : time.getMinutes()
  var s = time.getSeconds() < 10 ? '0' + time.getSeconds() : time.getSeconds()
  return y + '-' + m + '-' + d + ' ' + h + ':' + mm + ':' + s
})
Vue.filter('formatDayForAnalyse', function (timeStr) {
  if (timeStr === 0) {
    return '1970-1-1'
  }
  var time = new Date(timeStr * 1000)
  var y = time.getFullYear()
  var m = time.getMonth() + 1
  var d = time.getDate()
  return y + '-' + m + '-' + d
})
Vue.filter('formatDay', function (timeStr) {
  if (timeStr === 0) {
    return '----'
  }
  var time = new Date(timeStr * 1000)
  var y = time.getFullYear()
  var m = time.getMonth() + 1
  var d = time.getDate()
  return y + '-' + m + '-' + d
})
Vue.filter('formatTime', function (timeStr) {
  if (timeStr === 0) {
    return '----'
  }
  var time = new Date(timeStr * 1000)
  var h = time.getHours() < 10 ? '0' + time.getHours() : time.getHours()
  var mm = time.getMinutes() < 10 ? '0' + time.getMinutes() : time.getMinutes()
  var s = time.getSeconds() < 10 ? '0' + time.getSeconds() : time.getSeconds()
  return h + ':' + mm + ':' + s
})
Vue.filter('showImgUrl', function (url) {
  if (typeof url === 'undefined') {
    return require('../assets/images/no-image.png')
  } else {
    let isContentStr = url.indexOf('http') >= 0
    if (isContentStr) {
      return url
    } else if (url && !isContentStr) {
      return API_IMG_HOST + url
    }
    return require('../assets/images/no-image.png')
  }
})
Vue.filter('formatHigherSearchLine', function (item) {
  // 小查询组线换class
  if (item.terms[item.terms.length - 1].selectedOptions[0] === 'event') {
    if (item.terms[item.terms.length - 1].eventCheckbox1 === false && item.terms[item.terms.length - 1].eventCheckbox2 === false) {
      return 'small-switch-line-two'
    } else if (item.terms[item.terms.length - 1].eventCheckbox1 === true && item.terms[item.terms.length - 1].eventCheckbox2 === false) {
      return 'small-switch-line-three'
    } else if (item.terms[item.terms.length - 1].eventCheckbox1 === false && item.terms[item.terms.length - 1].eventCheckbox2 === true) {
      return 'small-switch-line-four'
    } else if (item.terms[item.terms.length - 1].eventCheckbox1 === true && item.terms[item.terms.length - 1].eventCheckbox2 === true) {
      return 'small-switch-line-five'
    }
  } else {
    return 'small-switch-line'
  }
})
Vue.filter('formatHigherSearchAndOr', function (item) {
  // 小查询组且或关系换class
  if (item.terms[item.terms.length - 1].selectedOptions[0] === 'event') {
    if (item.terms[item.terms.length - 1].eventCheckbox1 === false && item.terms[item.terms.length - 1].eventCheckbox2 === false) {
      return 'small-switch-content-two'
    } else if (item.terms[item.terms.length - 1].eventCheckbox1 === true && item.terms[item.terms.length - 1].eventCheckbox2 === false) {
      return 'small-switch-content-three'
    } else if (item.terms[item.terms.length - 1].eventCheckbox1 === false && item.terms[item.terms.length - 1].eventCheckbox2 === true) {
      return 'small-switch-content-four'
    } else if (item.terms[item.terms.length - 1].eventCheckbox1 === true && item.terms[item.terms.length - 1].eventCheckbox2 === true) {
      return 'small-switch-content-five'
    }
  } else {
    return 'small-switch-content'
  }
})
Vue.filter('formatCusHigherSearchLine', function (item) {
  // 受众高级查询--小查询组线换class
  if (item.terms[item.terms.length - 1].selectedOptions[0] === 'event') {
    if (item.terms[item.terms.length - 1].eventLimitTime === false && item.terms[item.terms.length - 1].eventLimitTimes === false && item.terms[item.terms.length - 1].eventLimitAttr === false) {
      return 'small-switch-line-two'
    } else if (item.terms[item.terms.length - 1].eventLimitTime === true && item.terms[item.terms.length - 1].eventLimitTimes === false && item.terms[item.terms.length - 1].eventLimitAttr === false) {
      return 'small-switch-line-three'
    } else if (item.terms[item.terms.length - 1].eventLimitTime === false && item.terms[item.terms.length - 1].eventLimitTimes === true && item.terms[item.terms.length - 1].eventLimitAttr === false) {
      return 'small-switch-line-four'
    } else if (item.terms[item.terms.length - 1].eventLimitTime === false && item.terms[item.terms.length - 1].eventLimitTimes === false && item.terms[item.terms.length - 1].eventLimitAttr === true) {
      if (item.terms[item.terms.length - 1].eventAttrOptions.length === 1) {
        return 'small-switch-line-five'
      }
      if (item.terms[item.terms.length - 1].eventAttrOptions.length === 2) {
        return 'small-switch-line-five1'
      }
      if (item.terms[item.terms.length - 1].eventAttrOptions.length === 3) {
        return 'small-switch-line-five2'
      }
      if (item.terms[item.terms.length - 1].eventAttrOptions.length === 4) {
        return 'small-switch-line-five3'
      }
      if (item.terms[item.terms.length - 1].eventAttrOptions.length === 5) {
        return 'small-switch-line-five4'
      }
      if (item.terms[item.terms.length - 1].eventAttrOptions.length === 6) {
        return 'small-switch-line-five5'
      }
      if (item.terms[item.terms.length - 1].eventAttrOptions.length === 7) {
        return 'small-switch-line-five6'
      }
      if (item.terms[item.terms.length - 1].eventAttrOptions.length === 8) {
        return 'small-switch-line-five7'
      }
    } else if (item.terms[item.terms.length - 1].eventLimitTime === true && item.terms[item.terms.length - 1].eventLimitTimes === true && item.terms[item.terms.length - 1].eventLimitAttr === true) {
      // return 'small-switch-line-six'
      if (item.terms[item.terms.length - 1].eventAttrOptions.length === 1) {
        return 'small-switch-line-six'
      }
      if (item.terms[item.terms.length - 1].eventAttrOptions.length === 2) {
        return 'small-switch-line-six1'
      }
      if (item.terms[item.terms.length - 1].eventAttrOptions.length === 3) {
        return 'small-switch-line-six2'
      }
      if (item.terms[item.terms.length - 1].eventAttrOptions.length === 4) {
        return 'small-switch-line-six3'
      }
      if (item.terms[item.terms.length - 1].eventAttrOptions.length === 5) {
        return 'small-switch-line-six4'
      }
      if (item.terms[item.terms.length - 1].eventAttrOptions.length === 6) {
        return 'small-switch-line-six5'
      }
      if (item.terms[item.terms.length - 1].eventAttrOptions.length === 7) {
        return 'small-switch-line-six6'
      }
      if (item.terms[item.terms.length - 1].eventAttrOptions.length === 8) {
        return 'small-switch-line-six7'
      }
    } else if (item.terms[item.terms.length - 1].eventLimitTime === true && item.terms[item.terms.length - 1].eventLimitTimes === true && item.terms[item.terms.length - 1].eventLimitAttr === false) {
      return 'small-switch-line-seven'
    } else if (item.terms[item.terms.length - 1].eventLimitTime === true && item.terms[item.terms.length - 1].eventLimitTimes === false && item.terms[item.terms.length - 1].eventLimitAttr === true) {
      if (item.terms[item.terms.length - 1].eventAttrOptions.length === 1) {
        return 'small-switch-line-eight'
      }
      if (item.terms[item.terms.length - 1].eventAttrOptions.length === 2) {
        return 'small-switch-line-eight1'
      }
      if (item.terms[item.terms.length - 1].eventAttrOptions.length === 3) {
        return 'small-switch-line-eight2'
      }
      if (item.terms[item.terms.length - 1].eventAttrOptions.length === 4) {
        return 'small-switch-line-eight3'
      }
      if (item.terms[item.terms.length - 1].eventAttrOptions.length === 5) {
        return 'small-switch-line-eight4'
      }
      if (item.terms[item.terms.length - 1].eventAttrOptions.length === 6) {
        return 'small-switch-line-eight5'
      }
      if (item.terms[item.terms.length - 1].eventAttrOptions.length === 7) {
        return 'small-switch-line-eight6'
      }
      if (item.terms[item.terms.length - 1].eventAttrOptions.length === 8) {
        return 'small-switch-line-eight7'
      }
    } else if (item.terms[item.terms.length - 1].eventLimitTime === false && item.terms[item.terms.length - 1].eventLimitTimes === true && item.terms[item.terms.length - 1].eventLimitAttr === true) {
      // return 'small-switch-line-nine'
      if (item.terms[item.terms.length - 1].eventAttrOptions.length === 1) {
        return 'small-switch-line-eight'
      }
      if (item.terms[item.terms.length - 1].eventAttrOptions.length === 2) {
        return 'small-switch-line-eight1'
      }
      if (item.terms[item.terms.length - 1].eventAttrOptions.length === 3) {
        return 'small-switch-line-eight2'
      }
      if (item.terms[item.terms.length - 1].eventAttrOptions.length === 4) {
        return 'small-switch-line-eight3'
      }
      if (item.terms[item.terms.length - 1].eventAttrOptions.length === 5) {
        return 'small-switch-line-eight4'
      }
      if (item.terms[item.terms.length - 1].eventAttrOptions.length === 6) {
        return 'small-switch-line-eight5'
      }
      if (item.terms[item.terms.length - 1].eventAttrOptions.length === 7) {
        return 'small-switch-line-eight6'
      }
      if (item.terms[item.terms.length - 1].eventAttrOptions.length === 8) {
        return 'small-switch-line-eight7'
      }
    }
  } else {
    return 'small-switch-line'
  }
})
Vue.filter('formatCusHigherSearchAndOr', function (item) {
  // 受众高级查询--小查询组且或关系换class
  if (item.terms[item.terms.length - 1].selectedOptions[0] === 'event') {
    console.log('aiwoqu0')
    if (item.terms[item.terms.length - 1].eventLimitTime === false && item.terms[item.terms.length - 1].eventLimitTimes === false && item.terms[item.terms.length - 1].eventLimitAttr === false) {
      console.log('aiwoqu1')
      return 'small-switch-content-two'
    } else if (item.terms[item.terms.length - 1].eventLimitTime === true && item.terms[item.terms.length - 1].eventLimitTimes === false && item.terms[item.terms.length - 1].eventLimitAttr === false) {
      return 'small-switch-content-three'
    } else if (item.terms[item.terms.length - 1].eventLimitTime === false && item.terms[item.terms.length - 1].eventLimitTimes === true && item.terms[item.terms.length - 1].eventLimitAttr === false) {
      return 'small-switch-content-four'
    } else if (item.terms[item.terms.length - 1].eventLimitTime === false && item.terms[item.terms.length - 1].eventLimitTimes === false && item.terms[item.terms.length - 1].eventLimitAttr === true) {
      if (item.terms[item.terms.length - 1].eventAttrOptions.length === 1) {
        return 'small-switch-content-five'
      }
      if (item.terms[item.terms.length - 1].eventAttrOptions.length === 2) {
        return 'small-switch-content-five1'
      }
      if (item.terms[item.terms.length - 1].eventAttrOptions.length === 3) {
        return 'small-switch-content-five2'
      }
      if (item.terms[item.terms.length - 1].eventAttrOptions.length === 4) {
        return 'small-switch-content-five3'
      }
      if (item.terms[item.terms.length - 1].eventAttrOptions.length === 5) {
        return 'small-switch-content-five4'
      }
      if (item.terms[item.terms.length - 1].eventAttrOptions.length === 6) {
        return 'small-switch-content-five5'
      }
      if (item.terms[item.terms.length - 1].eventAttrOptions.length === 7) {
        return 'small-switch-content-five6'
      }
      if (item.terms[item.terms.length - 1].eventAttrOptions.length === 8) {
        return 'small-switch-content-five7'
      }
    } else if (item.terms[item.terms.length - 1].eventLimitTime === true && item.terms[item.terms.length - 1].eventLimitTimes === true && item.terms[item.terms.length - 1].eventLimitAttr === true) {
      // return 'small-switch-content-six'
      if (item.terms[item.terms.length - 1].eventAttrOptions.length === 1) {
        return 'small-switch-content-six'
      }
      if (item.terms[item.terms.length - 1].eventAttrOptions.length === 2) {
        return 'small-switch-content-six1'
      }
      if (item.terms[item.terms.length - 1].eventAttrOptions.length === 3) {
        return 'small-switch-content-six2'
      }
      if (item.terms[item.terms.length - 1].eventAttrOptions.length === 4) {
        return 'small-switch-content-six3'
      }
      if (item.terms[item.terms.length - 1].eventAttrOptions.length === 5) {
        return 'small-switch-content-six4'
      }
      if (item.terms[item.terms.length - 1].eventAttrOptions.length === 6) {
        return 'small-switch-content-six5'
      }
      if (item.terms[item.terms.length - 1].eventAttrOptions.length === 7) {
        return 'small-switch-content-six6'
      }
      if (item.terms[item.terms.length - 1].eventAttrOptions.length === 8) {
        return 'small-switch-content-six7'
      }
    } else if (item.terms[item.terms.length - 1].eventLimitTime === true && item.terms[item.terms.length - 1].eventLimitTimes === true && item.terms[item.terms.length - 1].eventLimitAttr === false) {
      return 'small-switch-content-seven'
    } else if (item.terms[item.terms.length - 1].eventLimitTime === true && item.terms[item.terms.length - 1].eventLimitTimes === false && item.terms[item.terms.length - 1].eventLimitAttr === true) {
      if (item.terms[item.terms.length - 1].eventAttrOptions.length === 1) {
        return 'small-switch-content-eight'
      }
      if (item.terms[item.terms.length - 1].eventAttrOptions.length === 2) {
        return 'small-switch-content-eight1'
      }
      if (item.terms[item.terms.length - 1].eventAttrOptions.length === 3) {
        return 'small-switch-content-eight2'
      }
      if (item.terms[item.terms.length - 1].eventAttrOptions.length === 4) {
        return 'small-switch-content-eight3'
      }
      if (item.terms[item.terms.length - 1].eventAttrOptions.length === 5) {
        return 'small-switch-content-eight4'
      }
      if (item.terms[item.terms.length - 1].eventAttrOptions.length === 6) {
        return 'small-switch-content-eight5'
      }
      if (item.terms[item.terms.length - 1].eventAttrOptions.length === 7) {
        return 'small-switch-content-eight6'
      }
      if (item.terms[item.terms.length - 1].eventAttrOptions.length === 8) {
        return 'small-switch-content-eight7'
      }
    } else if (item.terms[item.terms.length - 1].eventLimitTime === false && item.terms[item.terms.length - 1].eventLimitTimes === true && item.terms[item.terms.length - 1].eventLimitAttr === true) {
      // return 'small-switch-content-nine'
      if (item.terms[item.terms.length - 1].eventAttrOptions.length === 1) {
        return 'small-switch-content-eight'
      }
      if (item.terms[item.terms.length - 1].eventAttrOptions.length === 2) {
        return 'small-switch-content-eight1'
      }
      if (item.terms[item.terms.length - 1].eventAttrOptions.length === 3) {
        return 'small-switch-content-eight2'
      }
      if (item.terms[item.terms.length - 1].eventAttrOptions.length === 4) {
        return 'small-switch-content-eight3'
      }
      if (item.terms[item.terms.length - 1].eventAttrOptions.length === 5) {
        return 'small-switch-content-eight4'
      }
      if (item.terms[item.terms.length - 1].eventAttrOptions.length === 6) {
        return 'small-switch-content-eight5'
      }
      if (item.terms[item.terms.length - 1].eventAttrOptions.length === 7) {
        return 'small-switch-content-eight6'
      }
      if (item.terms[item.terms.length - 1].eventAttrOptions.length === 8) {
        return 'small-switch-content-eight7'
      }
    }
  } else {
    return 'small-switch-content'
  }
})
Vue.filter('formatAudHigherSearch', function (item) {
  // 小查询组线换class
  if (item.length < 6) {
    let num = 100 / item.length
    return num + '%'
  } else {
    return 160
  }
})
